import { observer } from 'mobx-react-lite';
import PropTypes from 'prop-types';
import React from 'react';
import { colors } from '../../../../../../../../../colorVars';
import { useWebsocketStore } from '../../../../../../../../../stores/websocketStore/websocketProvider';
import ApplyRounding from '../../../../../../../../../utils/math/ApplyRounding';
import { HoverBox } from '../../../hoverBox/HoverBox';

export const PositionBreakPriceLine = observer(
  ({ tradePlanId, priceToBreak, size, scaleY, portalRef }) => {
    const { tradePlanStore } = useWebsocketStore();
    const tradePlan = tradePlanStore.tradePlans[tradePlanId] ?? null;
    const paused = tradePlan?.exitTactics['POSITION_BREAK_PRICE']?.paused ?? null;
    
    const json = {
      Category: 'Exit Tactic',
      Type: 'Position Break Price',
      'Break Price': ApplyRounding(Number(priceToBreak), 2),
    };

    return (
      <>
        {scaleY ? (
          <>
            {paused ? (
              <line
                strokeDasharray="4"
                stroke={colors.red}
                strokeWidth={2}
                x1={0}
                x2={size}
                y1={scaleY(Number(priceToBreak))}
                y2={scaleY(Number(priceToBreak))}
              />
            ) : (
              <line
                stroke={colors.red}
                strokeWidth={2}
                x1={0}
                x2={size}
                y1={scaleY(Number(priceToBreak))}
                y2={scaleY(Number(priceToBreak))}
              />
            )}

            <HoverBox
              json={json}
              topBoundary={scaleY(Number(priceToBreak)) - 2}
              bottomBoundary={scaleY(Number(priceToBreak)) + 2}
              leftBoundary={0}
              rightBoundary={size}
              portalRef={portalRef}
              size={size}
            />
          </>
        ) : null}
      </>
    );
  }
);

PositionBreakPriceLine.propTypes = {
  priceToBreak: PropTypes.number,
  scaleY: PropTypes.func,
  size: PropTypes.number,
  portalRef: PropTypes.object,
};
